export default function splitName(name) {
    const splitName = (name || '').split(' ');
    const firstName = splitName.shift();
    const lastName = splitName.join(' ');
    return [firstName, lastName];
};
